document.addEventListener('DOMContentLoaded', function() {
  const modalFirst = document.getElementById('modal__first');
  const modalSecond = document.getElementById('modal__second');
  const buttonFirst = document.querySelector('.button__first');
  const buttonSecond = document.querySelector('.button__second');
  const closeBtns = document.querySelectorAll('.modal__close');
  const body = document.body;

  function openModal(modal) {
    modal.style.display = 'block';
    body.classList.add('modal-open');
  }

  function closeModal(modal) {
    modal.style.display = 'none';
    body.classList.remove('modal-open');
  }

  function closeAllModals() {
    closeModal(modalFirst);
    closeModal(modalSecond);
  }

  buttonFirst.addEventListener('click', function() {
    openModal(modalFirst);
  });

  buttonSecond.addEventListener('click', function() {
    openModal(modalSecond);
  });

  closeBtns.forEach(closeBtn => {
    closeBtn.addEventListener('click', function() {
      closeAllModals();
    });
  });

  window.addEventListener('click', function(event) {
    if (event.target === modalFirst) {
      closeModal(modalFirst);
    }
    if (event.target === modalSecond) {
      closeModal(modalSecond);
    }
  });
});
